import { Grid, ListItem, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { RelatedList, RelatedListItem, RelatedSettings } from 'components/RelatedSettings'
import { CONTAINER_SPACING } from 'providers/material-ui/theme/constants'
import { INVOICE_DETAILS } from '../constants'

export const InvoiceDetailsSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/finance', { keyPrefix: 'invoiceDetails' })

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <Grid
        container
        sx={{ width: 'fit-content' }}
      >
        <Grid size={6}>
          <Grid
            container
            spacing={CONTAINER_SPACING}
          >
            <Grid size={6}>
              <Typography variant='subtitle1'>{t('companyName')}</Typography>
              <Typography>{INVOICE_DETAILS.companyName}</Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant='subtitle1'>{t('vat')}</Typography>
              <Typography>{INVOICE_DETAILS.vat}</Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant='subtitle1'>{t('address')}</Typography>
              <Typography>{INVOICE_DETAILS.address.street}</Typography>
              <Typography>{INVOICE_DETAILS.address.postalCode}</Typography>
            </Grid>

            <Grid size={6}>
              <Typography variant='subtitle1'>{t('email')}</Typography>
              <Typography
                component='a'
                href={`mailto:${INVOICE_DETAILS.email}`}
              >
                {INVOICE_DETAILS.email}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={4}>
          <RelatedSettings title={t('info.header')}>
            <RelatedList>
              <RelatedListItem content={t('info.polishCompanies')} />

              <ListItem
                disableGutters
                sx={{ display: 'list-item' }}
              >
                <Trans
                  components={{
                    a: (
                      <Typography
                        component='a'
                        href={`mailto:${INVOICE_DETAILS.email}`}
                      />
                    ),
                  }}
                  i18nKey='info.foreignCompanies'
                  t={t}
                  values={{ email: INVOICE_DETAILS.email }}
                />
              </ListItem>
            </RelatedList>
          </RelatedSettings>
        </Grid>
      </Grid>
    </Paper>
  )
}
